// eslint-disable-next-line
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import type { AccommodationsProps } from './Accommodations.types';

function shortenString(s = '', len = 10, suffix = '') {
  if (!len || len < 1) return [false, s];
  if (!s || s?.length < len) return [false, s];
  return [true, `${s.substring(0, len - 1)}${suffix}`];
}

function Accommodations({ item = {}, studentId = '', links = true }: AccommodationsProps) {
  const { pathname } = useLocation();
  const supplementalTextMaxLength = 15;
  const [textWasShortened, supplementalInfo] = shortenString(item?.supplementalInfo, supplementalTextMaxLength);
  const hasPrimaryText = !!item?.title || !!item?.description;

  if (!hasPrimaryText && !supplementalInfo) {
    return null;
  }

  return (
    <>
      {`${item?.title} - ${item?.description}`}
      {supplementalInfo ? (
        <span data-automation={`${item?.title}-supplementalInfo`}>
          <> - </>
          {supplementalInfo}
          {textWasShortened ? (
            links ? (
              <Link
                aria-label={`more accommodations for ${studentId}`}
                to={{
                  hash: '#accomm-list',
                  pathname: `/students/get/${studentId}`,
                }}
                state={{
                  from: pathname,
                }}
              >
                ...more
              </Link>
            ) : (
              <>...</>
            )
          ) : (
            ''
          )}
        </span>
      ) : (
        ''
      )}
    </>
  );
}

export default Accommodations;
